import { cx } from 'class-variance-authority';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

type EnvironmentIndicatorProps = {
  environment: 'sandbox' | 'production';
  disabled?: boolean;
};

const EnvironmentIndicator = forwardRef<HTMLSpanElement, EnvironmentIndicatorProps>(
  ({ environment, disabled }, ref) => {
    const { t } = useTranslation('common', {
      keyPrefix: 'components.privateLayout.nav.navHeader.sandboxToggle',
    });
    const isSandbox = environment === 'sandbox';
    return (
      <span className="flex items-center justify-start gap-2 pl-0.5" ref={ref}>
        <span
          className={cx('rounded-full size-1.5 relative flex-shrink-0', {
            '[animation:pulse_3s_cubic-bezier(0.4,0,0.6,1)_infinite]': !disabled,
            'bg-warning-inverted ring-2 ring-warning-inverted text-warning-inverted': isSandbox,
            'bg-success-inverted ring-2 ring-success-inverted text-success-inverted': !isSandbox,
            'opacity-50': disabled,
          })}
        >
          <span
            className={cx('absolute inset-0 rounded-full opacity-75', {
              '[animation:ping_3s_cubic-bezier(0,0,0.2,1)_infinite]': !disabled,
              'bg-warning-inverted': isSandbox,
              'bg-success-inverted': !isSandbox,
            })}
          />
        </span>
        <span className="text-nowrap">{isSandbox ? t($ => $.sandbox) : t($ => $.production)}</span>
      </span>
    );
  },
);

EnvironmentIndicator.displayName = 'EnvironmentIndicator';

export default EnvironmentIndicator;
